import {AttributeLink, AttributeSetup} from '@acng/frontend-stargazer';
import {Actor} from '../../layout/context/list.js';
import {ctxVotables, ctxVotes} from '../context/list';
import {Watch} from '@acng/frontend-relativity';
import {AmateurUpgrade, CreatorTemplateConfig} from 'acng/amateurPool/service/template';
import {get} from 'acng/amateurPool/service/cache.js';
import {compile} from '../service/template.js';
import {add, remove, toggle} from '@acng/frontend-bounty/style/element.js';

/**
 * @group DOM Attribute
 */
const name = 'votable-list';

AttributeSetup(name, () => {
  const provide = Actor();
  const watch = Watch(`[${name}]`, ctxVotables);
  const watchVotes = Watch(`.${name}-item`, ctxVotes);
  const itemWatchVotables = Watch(`.${name}-item`, ctxVotables);

  AttributeLink(name, (element) => {
    watch(element, (element, list) => {
      console.log('VOTABLE', list);
      toggle(element, 'empty-votable-list', !list.length);
      toggle(element, 'filled-votable-list', !!list.length);

      provide(
        element,
        async () => [],
        async (amateur_id) => {
          let pos = 0;
          const amateur = await get(amateur_id);
          const config = CreatorTemplateConfig(amateur);
          config.image = amateur.getMatchMakerImageUrl('800');
          const link = AmateurUpgrade(amateur, config);
          return (element, engine) => {
            add(element, `${name}-item`);
            watchVotes(element, (element, votes) => {
              for (const vote of votes) {
                if (vote.amateur_id == parseInt(amateur_id)) {
                  add(element, vote.state);
                  break;
                }
              }
            });

            itemWatchVotables(element, (element, votables) => {
              if (pos > 1) {
                remove(element, `pos${pos}`);
              }

              pos = votables.indexOf(amateur.id) + 1;
              if (pos) {
                add(element, `pos${pos}`);
              }
            });
            return link(element, engine);
          };
        },
        [...list],
      );
    });
  });

  return compile;
});

export {name as VOTABLE_LIST};
